import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  SpacerV,
  FeatureCard,
  Stats,
} from "../components/Hero";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import SearchIcon from "@mui/icons-material/Search";
import WindowIcon from "@mui/icons-material/Window";
import TabIcon from "@mui/icons-material/Tab";
import DvrIcon from "@mui/icons-material/Dvr";
import BlurOnIcon from "@mui/icons-material/BlurOn";
import DoubleArrowIcon from "@mui/icons-material/DoubleArrow";
import { Fragment } from "react";
import Lottie from "react-lottie";
import StorageIcon from "@mui/icons-material/Storage";
import BarChartIcon from "@mui/icons-material/BarChart";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import DataUsageIcon from "@mui/icons-material/DataUsage";
import AssessmentIcon from "@mui/icons-material/Assessment";

export default function WebDesign() {
  useEffect(() => {}, []);

  const state = useSelector((state) => state);
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <Hero
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          title="Data Analytics"
          subtitle={
            <div>
              <p>
                Our data analytics expertise empowers businesses to make
                informed decisions, uncover insights, and drive growth. Here’s
                why we’re the right choice for your business:
              </p>
              {!state.auth.isMobile ? (
                <ul>
                  <li>
                    <strong>Advanced Data Insights</strong>: We leverage
                    cutting-edge tools and techniques to analyze complex data,
                    uncovering actionable insights for your business.
                  </li>
                  <li>
                    <strong>Customized Analytics Solutions</strong>: We tailor
                    our analytics strategies to meet your unique business needs,
                    ensuring measurable results and ROI.
                  </li>
                  <li>
                    <strong>Data Visualization & Reporting</strong>: We
                    transform raw data into clear, visually compelling reports
                    and dashboards for easy understanding and decision-making.
                  </li>
                </ul>
              ) : (
                ""
              )}
              <p>
                By hiring us, you gain a partner dedicated to turning your data
                into a strategic asset, helping you stay ahead in a competitive
                landscape.
              </p>
            </div>
          }
        />

        <ContentSideBySideInv
          title="Data Analytics Process"
          subtitle={
            <div style={{ marginLeft: "15px" }}>
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "orange",
                    marginRight: "15px",
                  }}
                />
                Data Collection & Preparation
              </div>
              The foundation of data analytics begins with collecting and
              cleaning raw data from various sources. This ensures accuracy and
              consistency for meaningful analysis.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "blue",
                    marginRight: "15px",
                  }}
                />
                Exploratory Data Analysis (EDA)
              </div>
              Exploratory Data Analysis helps uncover patterns, trends, and
              anomalies within datasets. This step provides crucial insights
              that drive decision-making.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "teal",
                    marginRight: "15px",
                  }}
                />
                Data Visualization
              </div>
              Data Visualization transforms raw insights into easily
              interpretable charts, graphs, and dashboards. This enhances
              understanding and communication of key findings.
              <br />
              <br />
              <div style={{ display: "flex", color: "black", fontWeight: 600 }}>
                <CheckCircleIcon
                  style={{
                    fontSize: "30px",
                    color: "purple",
                    marginRight: "15px",
                  }}
                />
                Predictive Analytics & Reporting
              </div>
              Using AI and machine learning models, predictive analytics
              forecasts future trends and behaviors. Regular reporting helps
              businesses track KPIs and optimize strategies.
            </div>
          }
          image={
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: require("../img/marketing (11).json"),
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
              }}
              height={state.auth.isMobile ? 350 : 500}
              width={state.auth.isMobile ? 350 : 500}
              isStopped={false}
              isPaused={false}
            />
          }
        />
        <SpacerV height={"100px"} />
        <SpacerV height={"100px"} />

        <ThreeSideBySide
          background={
            "linear-gradient(135deg, #992619 0%, #8e0e00 50%, #7f0c00 100%)"
          }
          spacing={5}
          subtitle1={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"Data Collection & Cleaning"}
                text={`Gather and clean data from various sources to ensure it’s accurate, reliable, and ready for analysis.`}
                icon={
                  <StorageIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Exploratory Data Analysis (EDA)"}
                text={`Perform in-depth analysis to uncover hidden patterns and insights in your data, helping you make data-driven decisions.`}
                icon={
                  <SearchIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle2={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"Data Visualization"}
                text={`Transform raw data into interactive and intuitive visualizations, making complex data more accessible and easier to interpret.`}
                icon={
                  <BarChartIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Predictive Analytics"}
                text={`Use machine learning models and statistical techniques to predict future trends and outcomes, providing valuable foresight.`}
                icon={
                  <TrendingUpIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
          subtitle3={
            <Fragment>
              <FeatureCard
                minHeight={"40vh"}
                title={"Data Warehousing"}
                text={`Centralize your data for easy and secure storage, making it accessible for real-time and historical analysis.`}
                icon={
                  <DataUsageIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
              <br />
              <br />
              <FeatureCard
                minHeight={"40vh"}
                title={"Reporting & Dashboards"}
                text={`Create real-time, interactive dashboards and reports for tracking key performance indicators (KPIs) and making informed decisions.`}
                icon={
                  <AssessmentIcon
                    style={{
                      fontSize: "50px",
                      color: "white",
                      marginRight: "15px",
                    }}
                  />
                }
                gradient={
                  "linear-gradient(0deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.2) 100%)"
                }
              />
            </Fragment>
          }
        />

        <Stats />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
